module.exports = __webpack_public_path__ + "img/login-banner.004eaff6.svg";